import React from 'react'
import { useDispatch } from 'react-redux'
import { setArScreen } from '../../redux/reducers/screens'
import distanceImage from '../../assets/Images/distance.png'
import streamLogo from '../../assets/Images/streamlogo-white.png'
import ButtonStart from '../ButtonStart'
import '../../styles/components/Instructions.scss'

const Instructions = () => {
  const dispatch = useDispatch()

  const handleClick = () => {
    dispatch(setArScreen())
  }

  return (
    <div className="Instructions" data-testid="instructions">
      <img className='Instructions__logo' src={streamLogo} alt="stream logo" />
      <img className='Instructions__distance' src={distanceImage} alt="distance" />
      <p>
        Stand 15 feet away from your current drive-thru menu or where you&apos;re drive-thru will be
        placed.
      </p>
      <ButtonStart onClick={handleClick}>BEGIN</ButtonStart>
    </div>
  )
}

export default Instructions
